import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';

@Component({
  selector: 'app-popin',
  templateUrl: './popin.component.html',
  standalone: true,
})
export class PopinComponent {
  @HostBinding('style.display') display = 'none';
  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() close = new EventEmitter();
  _show = false;

  @Input() set show(_show: boolean) {
    this._show = _show;
    if (this._show) {
      this.freezeBodyScroll();
      this.display = 'block';
      return;
    }

    this.unfreezeBodyScroll();
    this.display = 'none';
  }

  sendClose() {
    this.close.emit('');
  }

  private freezeBodyScroll() {
    document.body.style.overflow = 'hidden';
    window.onscroll = function () {
      window.scroll(0, 0);
    };
  }

  private unfreezeBodyScroll() {
    document.body.style.overflow = '';
    window.onscroll = null;
  }
}
